import NotFound from '@package/components/ErrorPages/NotFound/NotFound';

export default NotFound;
